export const SurveyTypes = {
    OPEN: process.env.REACT_APP_OPEN_SURVEY_ID,
    MULTIPLE_OPTION: process.env.REACT_APP_MULTIPLE_OPTION_SURVEY_ID,
    SCALE: process.env.REACT_APP_SCALE_SURVEY_ID,
    MULTIMEDIA: process.env.REACT_APP_MULTIMEDIA_SURVEY_ID,
    WARM_MAP: process.env.REACT_APP_WARM_MAP_SURVEY_ID
}